module.exports = __webpack_public_path__ + "media/images/top/review-sample01-4d686a1035649513965028f66e0c6eb2.jpg";